export class DepartmentAlreadyExistsMessage {
    public code: string;
    
    constructor(code: string)
    {
        this.code = code;
    }
}